import script from "./OpinionImages.vue?vue&type=script&setup=true&lang=js"
export * from "./OpinionImages.vue?vue&type=script&setup=true&lang=js"

import "./OpinionImages.vue?vue&type=style&index=0&id=08247b70&lang=scss"

const __exports__ = script;

export default __exports__